import * as React from 'react';
import DatePicker from 'react-datepicker';
import cx from 'classnames';

import Head from '~/common/layout/Head';

class TransactionListHeader extends React.Component<any, any> {
  filterRef;

  constructor(props) {
    super(props);

    this.filterRef = React.createRef();

    this.state = {
      startDate: null,
      endDate: null,
    };
  }

  onSearch = (e) => {
    e.preventDefault();

    this.props.onFilter(this.filterRef.current.value);
  };

  onExport = (e) => {
    e.preventDefault();

    const { startDate, endDate } = this.state;

    if (startDate && endDate) {
      this.props.onExport(startDate, endDate);
    }
  };

  setStartDate = (dt) => {
    this.setState({
      startDate: dt,
    });
  };

  setEndDate = (dt) => {
    this.setState({
      endDate: dt,
    });
  };

  render = () => {
    const { title, onExport } = this.props;
    const { startDate, endDate } = this.state;

    const btnClass = cx('btn btn--disabled btn--tert btn--lg', {
      'btn--disabled--active': startDate && endDate && startDate <= endDate,
    });

    return (
      <div className="head--data">
        <Head headTitle={title}>
          {onExport && (
            <React.Fragment>
              <div className="input--date">
                <DatePicker
                  onChange={this.setStartDate}
                  selected={this.state.startDate}
                  popperPlacement="bottom-end"
                  placeholderText="Start Date" />
              </div>
              <div className="btn btn--text--di btn--lg">TO</div>
              <div className="input--date">
                <DatePicker
                  onChange={this.setEndDate}
                  selected={this.state.endDate}
                  popperPlacement="bottom-end"
                  placeholderText="End Date" />
              </div>
              <a href="#" className={btnClass} onClick={this.onExport}>Export</a>
            </React.Fragment>
          )}
        </Head>
      </div>
    );
  }
}

export default TransactionListHeader;

